import React, { useState } from "react";
import { Input, Select } from "../../../shared/components";
import { usePatientForm } from "../hooks/usePatientForm";

const PatientForm = ({ initialData, onSubmit, onCancel }) => {
  const {
    formData,
    errors,
    departments,
    designations,
    handleChange,
  } = usePatientForm(initialData);

  const [step, setStep] = useState(1);
  const totalSteps = 4;

  const handleNext = () => {
    if (step < totalSteps) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.first_name?.trim()) {
      alert("First name is required");
      return;
    }

    if (!formData.mobile?.trim()) {
      alert("Mobile number is required");
      return;
    }

    if (!formData.gender) {
      alert("Gender is required");
      return;
    }

      if (!formData.employee_code) {
      alert("Employee Id is required");
      return;
    }

    onSubmit(formData);
  };

  const progressWidth = `${(step / totalSteps) * 100}%`;

  return (
    <div className="min-h-screen flex items-start justify-center p-6 bg-gradient-to-br from-blue-50 to-indigo-50">
      <form
        onSubmit={handleSubmit}
//        className="w-full max-w-6xl bg-white rounded-2xl shadow-xl p-10"
        className="w-full max-w-screen-xl bg-white rounded-2xl shadow-xl p-10"
        style={{ maxHeight: "90vh" }}
      >

        {/* Header */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800">
            {initialData ? "Update Patient" : "Add New Patient"}
          </h2>
          <p className="text-gray-500 text-sm">
            Fill patient information
          </p>
        </div>

        {/* Step Indicator */}
        <div className="mb-8">
          <div className="flex justify-between mb-3">
            {["Personal Info", "Work Info", "Emergency", "Medical Conditions"].map((label, i) => (
              <div key={label} className={`flex flex-col items-center ${i + 1 <= step ? "text-indigo-600" : "text-gray-400"}`}>
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${
                    i + 1 <= step
                      ? "bg-indigo-600 text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {i + 1}
                </div>
                <span className="text-xs mt-1">{label}</span>
              </div>
            ))}
          </div>

          <div className="w-full h-2 bg-gray-200 rounded-full">
            <div
              className="h-full bg-indigo-600 rounded-full"
              style={{ width: progressWidth }}
            />
          </div>
        </div>

        {/* Scroll area */}
        <div
          className="overflow-y-auto pr-2"
          style={{ maxHeight: "calc(90vh - 250px)" }}
        >

          {/* STEP 1 */}
          {step === 1 && (
            <section className="space-y-6 animate-fadeIn">

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}

                <Input
                  label="First Name *"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  error={errors.first_name}
                  placeholder="First Name"
                />
                <Input
                  label="Middle Name"
                  name="middle_name"
                  value={formData.middle_name}
                  onChange={handleChange}
                  placeholder="Middle Name"
                />

                <Input
                  label="Last Name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                />

              

                <Input
                  label="Mobile *"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  error={errors.mobile}
                  placeholder="Mobile Number"
                />

                <Input
                  label="Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="email@example.com"
                />

                <Select
                  label="Gender *"
                  name="gender"
                  value={formData.gender || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </Select>

                 <Select
                  label="Marital Status"
                  name="marital_status"
                  value={formData.marital_status || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Marital Status</option>
                  <option value="single">Single</option>
                  <option value="married">Married</option>
                  {/* <option value="separated">Separated</option> */}
                  <option value="divorced">Divorced</option>
                  <option value="widowed">Widowed</option>

                </Select>

                <Select
                  label="Blood Group"
                  name="blood_group"
                  value={formData.blood_group || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </Select>

                <Input
                  label="Date of birth"
                  type="date"
                  name="date_of_birth"
                  value={formData.date_of_birth}
                  onChange={handleChange}
                  placeholder="16"
                />

              </div>
            </section>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <section className="space-y-6 animate-fadeIn">

              {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Input
                  label="Employee ID *"
                  name="employee_code"
                  value={formData.employee_code}
                  onChange={handleChange}
                  placeholder="Employee ID"
                />

                <Select
                  label="Department"
                  name="department_id"
                  value={formData.department_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.name}
                    </option>
                  ))}
                </Select>

                <Select
                  label="Position"
                  name="designation_id"
                  value={formData.designation_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Position</option>
                  {designations.map((pos) => (
                    <option key={pos.id} value={pos.id}>
                      {pos.name}
                    </option>
                  ))}
                </Select>
                <Select
                  label="Employment Type"
                  name="employment_type"
                  value={formData.employment_type || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Employmemt Type</option>
                  <option value="permanent">Permanent</option>
                  <option value="contract">Contractual</option>
                  <option value="trainee">Trainee</option>
                  <option value="consultant">Consultant</option>
                </Select>

                {/* <Input
                  label="Hire Date"
                  type="date"
                  name="hire_date"
                  value={formData.hire_date}
                  onChange={handleChange}
                /> */}

                {/* <Input
                  label="Salary"
                  type="number"
                  name="salary"
                  value={formData.salary}
                  onChange={handleChange}
                /> */}

              </div>
            </section>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <section className="space-y-6 animate-fadeIn">

              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

                <Input
                  label="Emergency Contact Name"
                  name="emergency_contact_name"
                  value={formData.emergency_contact_name}
                  onChange={handleChange}
                />

                <Input
                  label="Emergency Contact Mobile"
                  name="emergency_contact_mobile"
                  value={formData.emergency_contact_mobile}
                  onChange={handleChange}
                />
                <Input
                  label="Emergency Contact Relation"
                  name="emergency_contact_relation"
                  value={formData.emergency_contact_relation}
                  onChange={handleChange}
                />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-6">

                 <Input
                  label="Current Address"
                  name="present_address"
                  value={formData.present_address}
                  onChange={handleChange}
                />
                <Input
                  label="Permanent Address"
                  name="permanent_address"
                  value={formData.permanent_address}
                  onChange={handleChange}
                />
                </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <Input
                  label="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                />
                <Input
                  label="State"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                />
                 <Input
                  label="Country"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                />
                 <Input
                  label="PIN Code"
                  name="pin_code"
                  value={formData.pin_code}
                  onChange={handleChange}
                />

              </div>

            </section>
          )}

          {/* STEP 4 */}
          {step === 4 && (
            <section className="space-y-6 animate-fadeIn">

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}

                <Input
                  label="Existing Medical Conditions"
                  name="existing_medical_conditions"
                  value={formData.existing_medical_conditions}
                  onChange={handleChange}
                />

                <Input
                  label="Known Allergies"
                  name="allergies"
                  value={formData.allergies}
                  onChange={handleChange}
                />
                <Input
                  label="Disabilities"
                  name="disabilities"
                  value={formData.disabilities}
                  onChange={handleChange}
                />
              </div>

            </section>
          )}
        </div>

        {/* Navigation */}
        <div className="flex justify-between mt-8 border-t pt-4">

          <div>
            {step > 1 && (
              <button
                type="button"
                onClick={handlePrev}
                className="px-4 py-2 border border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50"
              >
                ← Prev
              </button>
            )}

            {step < totalSteps && (
              <button
                type="button"
                onClick={handleNext}
                className="ml-2 px-4 py-2 border border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50"
              >
                Next →
              </button>
            )}
          </div>

          <div>
            {onCancel && (
              <button
                type="button"
                onClick={onCancel}
                className="mr-2 px-4 py-2 bg-gray-100 rounded-lg"
              >
                Cancel
              </button>
            )}

            <button
              type="submit"
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
            >
              {initialData ? "Update" : "Create"}
            </button>
          </div>
        </div>

      </form>
    </div>
  );
};

export default PatientForm;